'use strict';

/**
 * Id generator for Entities
 */
function notInitialized() {
  throw new Error('Id generator is not initialized');
}

export default {
  newId: notInitialized
};


// WEBPACK FOOTER //
// ./factories/lib/id_generator.js